export enum KeysLocalStorage{
  DATA_PATIENT = 'DATA_PATIENT',
  DATA_ACCREDITED = 'DATA_ACCREDITED',
}